export const candidatesStatus: {
  id: number;
  label: string;
  btnClass: string;
  class: string;
}[] = [
  {
    id: 0,
    label: 'Process initiated',
    btnClass: 'btn-pastel-gray',
    class: 'lnr lnr-hourglass'
  },
  {
    id: 1,
    label: 'Waitlisted',
    btnClass: 'btn-pastel-yellow',
    class: 'lnr lnr-hourglass'
  },
  {
    id: 2,
    label: 'Interview scheduled',
    btnClass: 'btn-pastel-yellow',
    class: 'lnr lnr-calendar-check'
  },
  {
    id: 3,
    label: 'Rejected',
    btnClass: 'btn-pastel-red',
    class: 'lnr lnr-cross'
  },
  {
    id: 4,
    label: 'Interviewed',
    btnClass: 'btn-pastel-green',
    class: 'lnr lnr-check'
  },
  {
    id: 5,
    label: 'Completed',
    btnClass: 'btn-pastel-green',
    class: 'lnr lnr-check'
  },
  {
    id: 6,
    label: 'Submitted',
    btnClass: 'btn-pastel-green',
    class: 'lnr lnr-check'
  },
  {
    id: 7,
    label: 'Accepted',
    btnClass: 'btn-pastel-green',
    class: 'lnr lnr-check'
  },
  {
    id: 8,
    label: 'Unresponsive',
    btnClass: 'btn-pastel-red',
    class: 'lnr lnr-warning'
  }
];
